import { find, findIndex, forEach } from 'lodash'
import { produce } from 'immer'
import { UserData } from '../apis/user.api'
import permissionService from './permission.service'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    users: UserData[],
    isAdmin: boolean
  ): TableHorizontalData<UserData>[] {
    forEach(users, (user: TableHorizontalData<UserData>) => {
      const actions: ActionName[] = ['edit']
      if (isAdmin) actions.push('token')
      const action: ActionName = user.isBlocked ? 'start' : 'resume'
      actions.push(action)
      user.actions = actions
      if (!user.permissions) return
      const permissionNames = permissionService.listNames(user.permissions)
      user.permissionNames = permissionNames.join(', ')
    })
    return users
  },

  block (users: TableHorizontalData<UserData>[], id: number) {
    return produce(users, users => {
      const user = find(users, { id })
      if (!user || !user.actions) return
      const index = findIndex(user.actions, 'resume')
      user.actions.splice(index, 1, 'start')
    })
  },

  unblock (users: TableHorizontalData<UserData>[], id: number) {
    return produce(users, users => {
      const user = find(users, { id })
      if (!user || !user.actions) return
      const index = findIndex(user.actions, 'start')
      user.actions.splice(index, 1, 'resume')
    })
  }
}
